import React from 'react';
import { Button, Typography } from '@mui/material';
import { trakrefBlue, trakrefDisabledBlue, focusColor } from '../../../color_utils';
import { trakrefFontFamilyBold } from '../../../utils';
import PropTypes from 'prop-types';

const largeButtonTextStyle = {
    padding: '1.5% 0%',
    color: '#fff',
    fontSize: '16px',
    fontFamily: trakrefFontFamilyBold,
    letterSpacing: '1px',
};

const ButtonWithIcon = ({
    id,
    buttonText,
    onClick,
    disabled,
    useLargeButton,
    fullWidth,
    width,
    size,
    Icon,
    iconPosition,
    sx,
    variant,
    color
}) => {
    const getBackgroundColor = () => {
        if (variant !== "contained") return "";
        return disabled ? trakrefDisabledBlue : trakrefBlue
    };
    
    const primaryButtonStyle = {
        '&.MuiButton-root': {
            fontFamily: trakrefFontFamilyBold,
            color,
            backgroundColor: getBackgroundColor(),
            letterSpacing: '1.2px',
        },
        '&:focus': { outline: `3px solid ${focusColor}` }
    };

    if (useLargeButton) {
        return (
            <Button
                id={id}
                size="large"
                variant={variant}
                startIcon={iconPosition === "start" ? <Icon /> : null}
                endIcon={iconPosition === "end" ? <Icon /> : null}
                onClick={onClick}
                fullWidth={fullWidth}      
                sx={{ ...primaryButtonStyle, width: `${width}%`, height: '52px', ...sx }}
                disabled={disabled}
            >
                <Typography variant='h5' sx={largeButtonTextStyle}>
                    {buttonText}
                </Typography>
            </Button>
        );
    }

    return (
        <Button
            id={id}
            variant={variant}
            startIcon={iconPosition === "start" ? <Icon /> : null}
            endIcon={iconPosition === "end" ? <Icon /> : null}
            size={size}
            onClick={onClick}
            fullWidth={fullWidth}
            sx={{ ...primaryButtonStyle, width: `${width}%`, ...sx }}
            disabled={disabled}
        >
            {buttonText}
        </Button>
    );
};

ButtonWithIcon.propTypes = {
    buttonText: PropTypes.string.isRequired,
    onClick: PropTypes.func.isRequired,
    id: PropTypes.string,
    fullWidth: PropTypes.bool,
    width: PropTypes.number,
    size: PropTypes.string,
    iconPosition: PropTypes.string,
    Icon: PropTypes.node.isRequired,
    useLargeButton: PropTypes.bool,
    sx: PropTypes.object,
    variant: PropTypes.string,
    color: PropTypes.string,
};

ButtonWithIcon.defaultProps = {
    id: "",
    fullWidth: false,
    width: null,
    size: "medium",
    iconPosition: "start",
    useLargeButton: false,
    sx: {},
    variant: "contained",
    color: "#FFF"
};

export default ButtonWithIcon;
